var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_55_8006)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 30,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_8006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4375 20H26.5625C22.9381 20 20 22.9381 20 26.5625V41.4375C20 45.0619 22.9381 48 26.5625 48H41.4375C45.0619 48 48 45.0619 48 41.4375V26.5625C48 22.9381 45.0619 20 41.4375 20Z",
    fill: "url(#paint0_radial_55_8006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4375 20H26.5625C22.9381 20 20 22.9381 20 26.5625V41.4375C20 45.0619 22.9381 48 26.5625 48H41.4375C45.0619 48 48 45.0619 48 41.4375V26.5625C48 22.9381 45.0619 20 41.4375 20Z",
    fill: "url(#paint1_radial_55_8006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.001 23.0625C31.0306 23.0625 30.6577 23.0755 29.4911 23.1286C28.3267 23.1819 27.5319 23.3662 26.8365 23.6367C26.117 23.9161 25.5068 24.2898 24.8989 24.8979C24.2905 25.5059 23.9167 26.1161 23.6365 26.8353C23.3653 27.5309 23.1807 28.3261 23.1283 29.4899C23.0762 30.6566 23.0625 31.0296 23.0625 34.0001C23.0625 36.9706 23.0756 37.3423 23.1286 38.5089C23.1822 39.6733 23.3665 40.4681 23.6367 41.1635C23.9163 41.883 24.29 42.4932 24.8981 43.1011C25.5059 43.7095 26.1161 44.0842 26.8351 44.3635C27.531 44.634 28.326 44.8183 29.4901 44.8717C30.6568 44.9247 31.0294 44.9377 33.9997 44.9377C36.9704 44.9377 37.3421 44.9247 38.5087 44.8717C39.6731 44.8183 40.4688 44.634 41.1647 44.3635C41.8839 44.0842 42.4932 43.7095 43.1009 43.1011C43.7093 42.4932 44.083 41.883 44.3633 41.1638C44.6321 40.4681 44.8167 39.6731 44.8714 38.5091C44.9238 37.3425 44.9375 36.9706 44.9375 34.0001C44.9375 31.0296 44.9238 30.6568 44.8714 29.4901C44.8167 28.3257 44.6321 27.531 44.3633 26.8356C44.083 26.1161 43.7093 25.5059 43.1009 24.8979C42.4925 24.2896 41.8841 23.9158 41.1641 23.6368C40.4668 23.3662 39.6715 23.1818 38.5071 23.1286C37.3404 23.0755 36.969 23.0625 33.9976 23.0625H34.001ZM33.0198 25.0335C33.311 25.0331 33.636 25.0335 34.001 25.0335C36.9214 25.0335 37.2675 25.044 38.4207 25.0964C39.4871 25.1452 40.0659 25.3234 40.4515 25.4731C40.9619 25.6713 41.3258 25.9083 41.7084 26.2912C42.0912 26.6741 42.3281 27.0386 42.5269 27.5491C42.6766 27.9341 42.855 28.5129 42.9036 29.5793C42.956 30.7323 42.9673 31.0786 42.9673 33.9976C42.9673 36.9166 42.956 37.263 42.9036 38.4159C42.8548 39.4823 42.6766 40.0611 42.5269 40.4462C42.3287 40.9567 42.0912 41.3201 41.7084 41.7027C41.3256 42.0855 40.9622 42.3225 40.4515 42.5208C40.0664 42.6711 39.4871 42.8489 38.4207 42.8977C37.2677 42.95 36.9214 42.9614 34.001 42.9614C31.0805 42.9614 30.7343 42.95 29.5814 42.8977C28.515 42.8484 27.9361 42.6703 27.5503 42.5205C27.0399 42.3222 26.6753 42.0853 26.2925 41.7025C25.9096 41.3197 25.6727 40.956 25.474 40.4454C25.3243 40.0602 25.1459 39.4814 25.0973 38.415C25.0449 37.262 25.0344 36.9157 25.0344 33.9949C25.0344 31.074 25.0449 30.7296 25.0973 29.5765C25.1461 28.5101 25.3243 27.9313 25.474 27.5458C25.6723 27.0353 25.9096 26.6708 26.2926 26.288C26.6755 25.9052 27.0399 25.6681 27.5504 25.4695C27.9359 25.3191 28.515 25.1414 29.5814 25.0924C30.5903 25.0468 30.9814 25.0331 33.0198 25.0308V25.0335ZM39.8394 26.8496C39.1148 26.8496 38.5269 27.437 38.5269 28.1617C38.5269 28.8863 39.1148 29.4742 39.8394 29.4742C40.564 29.4742 41.1519 28.8863 41.1519 28.1617C41.1519 27.4371 40.564 26.8492 39.8394 26.8492V26.8496ZM34.001 28.3832C30.8991 28.3832 28.3841 30.8981 28.3841 34.0001C28.3841 37.1021 30.8991 39.6159 34.001 39.6159C37.103 39.6159 39.6171 37.1021 39.6171 34.0001C39.6171 30.8982 37.1028 28.3832 34.0008 28.3832H34.001ZM34.001 30.3542C36.0145 30.3542 37.6469 31.9864 37.6469 34.0001C37.6469 36.0136 36.0145 37.646 34.001 37.646C31.9875 37.646 30.3552 36.0136 30.3552 34.0001C30.3552 31.9864 31.9874 30.3542 34.001 30.3542Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_55_8006",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_55_8006"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_8006"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_8006",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_55_8006",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4375 50.1565) rotate(-90) scale(27.7501 25.8098)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_55_8006",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3099 22.017) rotate(78.681) scale(12.4044 51.1315)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_8006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInsta);
export default __webpack_public_path__ + "static/media/profile_insta.80de347db36f1b7f7d554be78288380c.svg";
export { ForwardRef as ReactComponent };